var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ods-icon',{staticClass:"ods-actions-menu__button",attrs:{"name":"setting","size":"18"}})}
var staticRenderFns = []

export { render, staticRenderFns }